/* ==========================================================================
   KX Showcase — galéria (custom element) + görgetés az ajánlatkérő űrlapra
   A theme editorban a szekció újratöltése és a blokkok kijelölése is támogatott.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class KxGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.kx-stage');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.kx-slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.kx-thumb'));
      this.bar = this.querySelector('.kx-bar span');
      this.elCurrent = this.querySelector('[data-kx-current]');
      this.elLabel = this.querySelector('[data-kx-label]');

      if (!this.slides.length) return;

      this.index = 0;
      this.elapsed = 0;
      this.last = 0;
      this.paused = false;
      this.visible = true;
      this.editorHold = false;
      this.interval = (parseFloat(this.dataset.interval) || 4.5) * 1000;
      this.single = this.slides.length < 2;
      this.autoplay = this.dataset.autoplay === 'true' && !this.single && !REDUCED;

      this.classList.toggle('is-single', this.single);
      this.goTo(0);

      if (this.single) return;

      // vezérlők
      this.onPrev = function () { this.goTo(this.index - 1, true); }.bind(this);
      this.onNext = function () { this.goTo(this.index + 1, true); }.bind(this);
      var prev = this.querySelector('[data-kx-prev]');
      var next = this.querySelector('[data-kx-next]');
      if (prev) prev.addEventListener('click', this.onPrev);
      if (next) next.addEventListener('click', this.onNext);

      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { this.goTo(i, true); }.bind(this));
      }, this);

      this.onKey = function (e) {
        if (e.key === 'ArrowLeft') this.goTo(this.index - 1, true);
        if (e.key === 'ArrowRight') this.goTo(this.index + 1, true);
      }.bind(this);
      this.addEventListener('keydown', this.onKey);

      // mobil swipe
      var x0 = null;
      this.stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      this.stage.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var d = e.clientX - x0; x0 = null;
        if (Math.abs(d) > 40) this.goTo(this.index + (d < 0 ? 1 : -1), true);
      }.bind(this));

      if (!this.autoplay) return;

      // szünet: hover, fókusz, háttérfül, kigörgetés
      var pause = function () { this.paused = true; }.bind(this);
      var play = function () { this.paused = false; }.bind(this);
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', play);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', play);

      this.onVisibility = function () { this.visible = !document.hidden; }.bind(this);
      document.addEventListener('visibilitychange', this.onVisibility);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          this.visible = entries[0].isIntersecting && !document.hidden;
        }.bind(this), { threshold: 0.25 });
        this.observer.observe(this);
      }

      this.tick = this.tick.bind(this);
      this.raf = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.observer) this.observer.disconnect();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    goTo(next, manual) {
      var n = this.slides.length;
      this.index = ((next % n) + n) % n;

      this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === this.index); }, this);
      this.thumbs.forEach(function (t, i) {
        if (i === this.index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      }, this);

      if (this.elCurrent) this.elCurrent.textContent = pad(this.index + 1);
      if (this.elLabel) this.elLabel.textContent = this.slides[this.index].dataset.label || '';

      if (manual) {
        this.elapsed = 0;
        if (this.bar) this.bar.style.transform = 'scaleX(0)';
      }
    }

    tick(t) {
      if (!this.last) this.last = t;
      var dt = t - this.last;
      this.last = t;

      if (!this.paused && this.visible && !this.editorHold) {
        this.elapsed += dt;
        if (this.elapsed >= this.interval) { this.elapsed = 0; this.goTo(this.index + 1); }
      }
      if (this.bar) this.bar.style.transform = 'scaleX(' + (this.elapsed / this.interval).toFixed(4) + ')';
      this.raf = requestAnimationFrame(this.tick);
    }
  }

  if (!customElements.get('kx-gallery')) customElements.define('kx-gallery', KxGallery);

  /* ---- görgetés az ajánlatkérő űrlapra ---- */
  function scrollTo(target) {
    if (!target) return;
    target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    var first = target.querySelector('input:not([type="hidden"]), select, textarea');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, REDUCED ? 0 : 700);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-kx-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    scrollTo(target);
  });

  // sikeres beküldés után az űrlaphoz görgetünk
  document.addEventListener('DOMContentLoaded', function () {
    var posted = document.querySelector('[data-kx-posted]');
    if (posted) posted.scrollIntoView({ block: 'center' });
  });

  /* ---- theme editor ---- */
  document.addEventListener('shopify:block:select', function (e) {
    var gallery = e.target.closest('kx-gallery');
    if (!gallery || !gallery.goTo) return;
    var idx = parseInt(e.target.dataset.index, 10);
    if (!isNaN(idx)) gallery.goTo(idx, true);
    gallery.editorHold = true;
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var gallery = e.target.closest('kx-gallery');
    if (gallery) gallery.editorHold = false;
  });
})();
